export const  CompanyRoutes = {
    createCompany: "/admin/createCompany",
    getCompany: "/admin/getAll",
  
    
  };
    